import React, { Component } from "react";
import "./Contact.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

//images
import imgGitHub from "../../../assets/images/github.svg";
import imgInstagram from "../../../assets/images/instagram.svg";

class Contact extends Component {
	openGitHub() {
		window.open("https://github.com/lopdam", "_blank");
	}

	openInstagram() {
		window.open("https://www.instagram.com/lopdam.dev/", "_blank");
	}

	render() {
		return (
			<div id="contact" className="contact">
				<div className="contact-container col-12 col-sm-8 col-md-6 col-lg-4">
					<h2>
						Contact
						<br />
						Information
					</h2>
					<div className="divider"></div>
					<h3>
						Lopez Damian
						<br />
						<FontAwesomeIcon className="icon" icon={faMapMarkerAlt} />{" "}
						Guayaquil, Ecuador
					</h3>
					<p className="info">
						<span className="prefix">Linkedin:</span>
						<a
							className="phone"
							target="_blank"
							rel="noreferrer"
							href="https://www.linkedin.com/in/dennys-lopez-damian-0a7a16114"
						>
						Dennys Lopez Damian
							</a>
						<br />
						<span className="prefix">E-mail:</span>
						<a className="email" href="mailto:dennyslopez2013@gmail.com">
							dennyslopez2013@gmail.com
						</a>
						<br />
						<span className="prefix">Telegram:</span>
						<a
							className="email"
							href="https://t.me/lopdam"
							rel="noreferrer"
							target="_blank"
						>
							lopdam
						</a>
					</p>

					<div className="icons-contact">
						<img
							src={imgGitHub}
							alt="GitHub"
							className="icon-contact"
							onClick={this.openGitHub}
						/>
						<img
							src={imgInstagram}
							alt="Instagram"
							className="icon-contact"
							onClick={this.openInstagram}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default Contact;
